import { rtkApi } from "@/shared/api/rtkApi";

import type { SubscriptionChangePreview } from "../model/types/subscriptionChangePreview";

interface ChangePreviewArgs {
  toPriceId: string;
  userId?: string;
}

const SUBSCRIPTION_CHANGE_PREVIEW_TAG = "SubscriptionChangePreview";

const apiWithTags = rtkApi.enhanceEndpoints({
  addTagTypes: [SUBSCRIPTION_CHANGE_PREVIEW_TAG],
});

const subscriptionApi = apiWithTags.injectEndpoints({
  endpoints: (build) => ({
    getSubscriptionChangePreview: build.query<SubscriptionChangePreview, ChangePreviewArgs>({
      query: ({ toPriceId, userId }) => ({
        url: "/api/subscription/subscription_change_preview",
        method: "POST",
        body: {
          to_price_id: toPriceId,
          ...(userId !== undefined ? { user_id: userId } : {}),
        },
      }),
      providesTags: [SUBSCRIPTION_CHANGE_PREVIEW_TAG],
      keepUnusedDataFor: 600,
    }),
  }),
});

export const useGetSubscriptionChangePreviewQuery = subscriptionApi.useGetSubscriptionChangePreviewQuery;

export const invalidateSubscriptionChangePreview = () =>
  subscriptionApi.util.invalidateTags([SUBSCRIPTION_CHANGE_PREVIEW_TAG]);
